<template>
  <div
    id="introContainer"
    tabindex="0"
    @keydown="handleKey($event)"
    aria-label="Introduction box"
    aria-live="polite"
  >
    <div id="intro">
      <!-- <transition name="up" mode="out-in"> -->
        <div
          v-if="!choice"
          class="step first"
          tabindex="0"
        >
          <p >Welcome to presence-past presence-present presence-future, a meditation for trans* and disabled futures. Every visitor on this website makes a paragraph of the meditation appear for everyone. You can scroll to read more text or experience the appearance of new text. Being here is enough, you are not required to do anything in order to make the meditation unfold.</p>
          <p >You can press [N] at any time to focus the navigation menu, and [A] to bring up more accessibility options.</p>
          <p class="buttons">
            <span
              tabindex="0"
              role="button"
              aria-label="leave this webpage"
              @click.stop="back()"
              @keydown.space="back()"
              @keydown.enter="back()"
            >
              <kbd>[backspace]</kbd> back
            </span>
            <span
              tabindex="0"
              role="button"
              aria-label="join the meditation"
              @click.stop="choice = 1"
              @keydown.space="choice = 1"
              @keydown.enter="choice = 1"
            >
              <kbd>[space]</kbd> start
            </span>
          </p>
        </div>
        <div
          v-else-if="choice == 1"
          class="step second"
        >
          <p >Your presence is represented by a blob in the color of this text. Once it is your time, your blob will unfold a new paragraph for you.</p>
          <p class="buttons">
            <span
              tabindex="0"
              role="button"
              aria-label="start"
              @click.stop="$emit('endIntro')"
              @keydown.space="$emit('endIntro')"
              @keydown.enter="$emit('endIntro')"
            >
              <kbd>[space]</kbd>ok
            </span>
          </p>
        </div>
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  emits: [
    'endIntro'
  ],
  data() {
    return {
      choice: null,
    }
  },
  mounted() {
    // play itro file
   if (this.$store.state.location == 'meditation') {
     this.$el.focus()
   }
  },
  methods: {

    handleKey(e) {
      if (!this.choice) {
        if ( e.key == "Backspace" ) {
          this.back()
        } else if ( e.key == "Return" ) {
          this.choice = 1
        }
      } else {
        if (this.choice == 1) {
          if (e.key == 'Backspace') {
            this.choice = null
          } else if (e.key == ' ' || e.key == 'Return') {
            this.$emit('endIntro')
          }
        } else {
          if (e.key == 'Backspace') {
            this.choice = null
          } else if (e.key == ' ' || e.key == 'Return') {
            this.$emit('endIntro')
          }
        }
      }
    },

    back() {
      history.back()
    },
  }
}
</script>

<style scoped>

#introContainer {
  box-sizing: border-box;
  position: absolute;
  top: calc(0%); left: calc(100%);
  width: 100%; height: 100%;
  display: flex;
  z-index: 1000;
  transition: all var(--slow) ease;
}

#introContainer::before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: var(--dark1);
  opacity: 0.8;
}

#intro {
  box-sizing: border-box;
  position: relative;
  margin: auto;
  width: 35em;
  background: var(--dark1);
  padding: 1em;
  transition: all var(--slow) ease;
}

#intro .step p:first-of-type {
  margin-top: 0;
}
#intro .step p:last-of-type {
  margin-bottom: 0;
}

#intro .step .buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}

#intro .step .buttons span {
  flex-basis: 50%;
  text-align: center;
  color: var(--light2);
}
#intro .step .buttons span {
  margin: 0 1em;
  text-decoration: underline;
  cursor: pointer;
}
#intro .step .buttons span:hover,
#intro .step .buttons span:focus {
  background: var(--light2) ;
  color: var(--dark2);
}

.up-enter-active,
.up-leave-active {
  transition: all 0.3s ease;
}

.up-enter-from,
.up-leave-to {
  transform: translateY(-5em);
  opacity: 0;
}

.isMobile kbd {
  display: none;
}

</style>
